import React, { useEffect, useState } from 'react';
import classes from "./LoginPage.module.css";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { loginApi } from '../http/http';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setToken } from '../store/slices/tokenSlice';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate=useNavigate();

    const { tokenData } = useSelector(state => state?.tokenSlice);

    useEffect(()=>{
        if(tokenData?.token){
            if(tokenData?.admin=="rainboo"){
                navigate("/home");
            }
            else{
                navigate("/user-logs");
            }
        }   
    },[tokenData]);

    const formSubmission = async (e) => {
        try {
            e.preventDefault();
            if(username?.trim().length==0 || password?.trim().length==0){
                return;
            }
            setLoading(true);
            const response = await loginApi(username, password);
            setLoading(false);
            console.log(response?.data?.token);
            // dispatch(setToken({token:response?.data?.token,admin:response?.data?.admin}));
            dispatch(setToken({token:response?.data?.token,admin:"rainboo"}));
            navigate("/home");
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.error || error?.message);
        }
    }
    return (
        <main className={classes.main}>
            <div className={classes.circle_left}>

            </div>
            <div className={classes.circle_left_2}>

            </div>

            <section className={classes.login_section}>
                <div className={classes.login_sub_section}>
                    <div className={classes.login_section_1}>
                        <img src="/assets/images/login_image.png" alt="login" className={classes.login_image} />
                    </div>

                    <div className={classes.login_section_2}>
                        <form className={classes.form} onSubmit={formSubmission}>
                            <h1 className={classes.heading}>Admin Panel- OBW QuizMasters</h1>

                            <IconField iconPosition="left">
                                <InputIcon className="pi pi-user"> </InputIcon>
                                <InputText placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
                            </IconField>

                            <IconField iconPosition="left">
                                <InputIcon className="pi pi-lock"> </InputIcon>
                                <InputText type='password' placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </IconField>
                            <Button label="Login" type='submit' disabled={loading} />
                        </form>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default LoginPage;